import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=72571eaa&scoped=true&"
import script from "./pagination.vue?vue&type=script&lang=js&"
export * from "./pagination.vue?vue&type=script&lang=js&"
import style0 from "./pagination.vue?vue&type=style&index=0&id=72571eaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72571eaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tsunagaru-v3-app-mintenant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72571eaa')) {
      api.createRecord('72571eaa', component.options)
    } else {
      api.reload('72571eaa', component.options)
    }
    module.hot.accept("./pagination.vue?vue&type=template&id=72571eaa&scoped=true&", function () {
      api.rerender('72571eaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/src/shared/components/pagination.vue"
export default component.exports